export default {
    ADD_NOTIFICATIONS : 'ADD_NOTIFICATIONS',
    REMOVE_NOTIFICATIONS: 'REMOVE_NOTIFICATIONS',
    CLEAR_NOTIFICATIONS: 'CLEAR_NOTIFICATIONS',
    DELETE_NOTIFICATION: 'DELETE_NOTIFICATION'
}